/**
 * HTTP Client Error Classes
 * Custom error types for better error handling and debugging
 */

import { logger } from '@/utils/logger'

/**
 * Base HTTP error class
 */
export class HttpError extends Error {
  public readonly status: number
  public readonly statusText: string
  public readonly headers: Headers
  public readonly response?: Response
  public readonly request?: RequestInit

  constructor(
    message: string,
    status: number,
    statusText: string,
    headers: Headers = new Headers(),
    response?: Response,
    request?: RequestInit
  ) {
    super(message)
    this.name = 'HttpError'
    this.status = status
    this.statusText = statusText
    this.headers = headers
    this.response = response
    this.request = request

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpError)
    }

    // Log error
    logger.error(`HTTP Error ${status}: ${message}`, {
      status,
      statusText,
    })
  }
}

/**
 * Check if error is an HTTP-related error
 */
export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError
}
